import { ArrowsLeftRightIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Convert = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ArrowsLeftRightIcon {...rest} size={Sizes[size]} color={fill} />;
};

Convert.displayName = 'Convert';
